import { __rest } from "tslib";
import DataStub from './DataStub';
/**
 * 从 DataSchema 生成默认值
 */
/* istanbul ignore next */
export default function getDefaultValue(schema, opts) {
    const _a = opts || {}, { context, exprContext } = _a, rest = __rest(_a, ["context", "exprContext"]);
    return new DataStub({
        schema,
        context,
        exprContext,
    }).getDefaultValue(rest);
}
